/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface TagChangeDataArithmetics
 *
 */
// create custom validators for the regexes
export interface TagChangeDataArithmetics {
    /**
     *
     * #type string
     * #memberof TagChangeDataArithmetics
        
        
         */
    operation: string;
    /**
     *
     * #type string
     * #memberof TagChangeDataArithmetics
        
        
         */
    tag1: string;
    /**
     *
     * #type string
     * #memberof TagChangeDataArithmetics
        
        
         */
    tag2: string;
}
/**
 * Check if a given object implements the TagChangeDataArithmetics interface.
 */
export function instanceOfTagChangeDataArithmetics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "operation" in value;
    isInstance = isInstance && "tag1" in value;
    isInstance = isInstance && "tag2" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const TagChangeDataArithmeticsTypiaAssertEquals = (input: any) => {
    return ((input: any): TagChangeDataArithmetics => {
        const __is = (input: any, _exceptionable: boolean = true): input is TagChangeDataArithmetics => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.operation && "string" === typeof input.tag1 && "string" === typeof input.tag2 && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["operation", "tag1", "tag2"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagChangeDataArithmetics => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "string",
                    value: input.operation
                })) && ("string" === typeof input.tag1 || $guard(_exceptionable, {
                    path: _path + ".tag1",
                    expected: "string",
                    value: input.tag1
                })) && ("string" === typeof input.tag2 || $guard(_exceptionable, {
                    path: _path + ".tag2",
                    expected: "string",
                    value: input.tag2
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["operation", "tag1", "tag2"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataArithmetics",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataArithmetics",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const TagChangeDataArithmeticsTypiaAssertStringify = (input: TagChangeDataArithmetics): string => {
    return ((input: any): string => { const assert = (input: any): TagChangeDataArithmetics => {
        const __is = (input: any): input is TagChangeDataArithmetics => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).operation && "string" === typeof (input as any).tag1 && "string" === typeof (input as any).tag2);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagChangeDataArithmetics => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "string",
                    value: input.operation
                })) && ("string" === typeof input.tag1 || $guard(_exceptionable, {
                    path: _path + ".tag1",
                    expected: "string",
                    value: input.tag1
                })) && ("string" === typeof input.tag2 || $guard(_exceptionable, {
                    path: _path + ".tag2",
                    expected: "string",
                    value: input.tag2
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataArithmetics",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagChangeDataArithmetics",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: TagChangeDataArithmetics): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"operation":${$string((input as any).operation)},"tag1":${$string((input as any).tag1)},"tag2":${$string((input as any).tag2)}}`;
    }; return stringify(assert(input)); })(input);
};
export const TagChangeDataArithmeticsValidatorShape = {
    'operation': yup.string().defined(),
    'tag1': yup.string().defined(),
    'tag2': yup.string().defined(),
};
export const TagChangeDataArithmeticsValidator = yup.object().shape(TagChangeDataArithmeticsValidatorShape);
export const TagChangeDataArithmeticsStringifyShapeProperties: ObjectSchema['properties'] = {
    'operation': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'tag1': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'tag2': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const TagChangeDataArithmeticsStringifyShape: ObjectSchema = {
    title: 'TagChangeDataArithmetics Stringifier',
    type: 'object',
    properties: {
        ...TagChangeDataArithmeticsStringifyShapeProperties
    },
    required: [
        'operation',
        'tag1',
        'tag2',
    ],
};
export const TagChangeDataArithmeticsStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TagChangeDataArithmeticsStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const TagChangeDataArithmeticsStringify: (data: TagChangeDataArithmetics) => string = TagChangeDataArithmeticsStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function TagChangeDataArithmeticsFromJSON(json: any): TagChangeDataArithmetics {
    return TagChangeDataArithmeticsFromJSONTyped(json, false);
}
export function TagChangeDataArithmeticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagChangeDataArithmetics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'operation': json['operation'],
        'tag1': json['tag1'],
        'tag2': json['tag2'],
    };
}
export function TagChangeDataArithmeticsToJSON(value?: TagChangeDataArithmetics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'operation': value.operation,
        'tag1': value.tag1,
        'tag2': value.tag2,
    };
}
